import React from "react";
import {Nav, Navbar} from 'react-bootstrap';
import {withTranslation} from 'react-i18next';
import {Tooltip as ReactTooltip} from 'react-tooltip';
import {SiFacebook, SiInstagram, SiTiktok} from 'react-icons/si';
import {RiTwitterXLine} from "react-icons/ri";
import {CH_COPYRIGHTS} from "../services/constant";
import "./styles/CFooter2.css"

class CFooter2 extends React.Component {

    render() {
        const {t} = this.props;
        return (<>
            <div className="largeScreen">
                <Navbar sticky="bottom" expand="md" ref={this.wrapper}
                        className="footer justify-content-center topfooter" bg="light"
                        data-bs-theme="light">
                    <Nav.Link className="footerSection" href="/about">{t('common.legal')}</Nav.Link>
                    <Nav>|</Nav>
                    <Nav.Link className="footerSection" href="/cgv"
                              title={t('common.conditionsFull')}>{t('common.cgv')}</Nav.Link>
                    <Nav>|</Nav>
                    <Nav.Link className="footerSection" href="/livraison">{t('common.shipping')}</Nav.Link>
                    <Nav>|</Nav>
                    {/*
                <Nav.Link className="footerSection" href="/who">{t('common.who')}</Nav.Link>
                <Nav>|</Nav>
                */}
                    <Nav.Link className="footerSection" href="/contact">{t('common.contact')}</Nav.Link>
                    <Nav>|</Nav>
                    <Nav.Link className="footerSection" href="/donnees">{t('common.personalData')}</Nav.Link>
                    <Nav>|</Nav>
                    <Nav.Link className="footerSection" href="/cookies"
                              title={t('common.cookiesTitle')}>{t('common.cookies')}</Nav.Link>
                </Navbar>
                <Navbar sticky="bottom" expand="md" ref={this.wrapper}
                        className="footer justify-content-center" bg="light"
                        data-bs-theme="light">
                    <Nav>{CH_COPYRIGHTS}</Nav>
                    <Nav.Link className="footerIcon" target="_social"
                              href="https://www.tiktok.com/@creharmony"
                              data-tooltip-content="TikTok: @creharmony"
                              data-tooltip-id="ttFooterTooltip"><SiTiktok/></Nav.Link>
                    <Nav.Link className="footerIcon" target="_social"
                              href="https://www.facebook.com/creharmony"
                              data-tooltip-content="Facebook: creharmony"
                              data-tooltip-id="ttFooterTooltip"><SiFacebook/></Nav.Link>
                    <Nav.Link className="footerIcon" target="_social"
                              href="https://twitter.com/creharmony"
                              data-tooltip-content="X (ex. Twitter): creharmony"
                              data-tooltip-id="ttFooterTooltip"><RiTwitterXLine/></Nav.Link>
                    <Nav.Link className="footerIcon" target="_social"
                              href="https://www.instagram.com/_creharmony_"
                              data-tooltip-content="Instagram: _creharmony_"
                              data-tooltip-id="ttFooterTooltip"><SiInstagram/></Nav.Link>
                    <ReactTooltip id="ttFooterTooltip"/>
                </Navbar>
            </div>
            <div className="smallScreen">
                <Navbar expand="md" ref={this.wrapper}
                        className="footer justify-content-center topfooter" bg="light"
                        data-bs-theme="light">
                    <Nav.Link className="footerSection" href="/about">{t('common.legal')}</Nav.Link>
                    <Nav className="footerSep" >&#160;</Nav>
                    <Nav.Link className="footerSection" href="/cgv"
                              title={t('common.conditionsFull')}>{t('common.cgv')}</Nav.Link>
                    <Nav className="footerSep" >&#160;</Nav>
                    <Nav.Link className="footerSection" href="/livraison">{t('common.shipping')}</Nav.Link>
                    <Nav className="footerSep" >&#160;</Nav>
                    <Nav.Link className="footerSection" href="/contact">{t('common.contact')}</Nav.Link>
                    <Nav className="footerSep" >&#160;</Nav>
                    <Nav.Link className="footerSection" href="/donnees">{t('common.personalData')}</Nav.Link>
                    <Nav className="footerSep" >&#160;</Nav>
                    <Nav.Link className="footerSection" href="/cookies"
                              title={t('common.cookiesTitle')}>{t('common.cookies')}</Nav.Link>
                </Navbar>
                <Navbar expand="md" ref={this.wrapper}
                        className="footer justify-content-center" bg="light"
                        data-bs-theme="light">
                    <Nav>{CH_COPYRIGHTS}</Nav>
                    <Nav className="footerSep" >&#160;</Nav>
                    <Nav.Link className="footerIcon" target="_social"
                              href="https://www.tiktok.com/@creharmony"
                              data-tooltip-content="TikTok: @creharmony"
                              data-tooltip-id="ttFooterTooltip"><SiTiktok/></Nav.Link>
                    <Nav className="footerSep" >&#160;</Nav>
                    <Nav.Link className="footerIcon" target="_social"
                              href="https://www.facebook.com/creharmony"
                              data-tooltip-content="Facebook: creharmony"
                              data-tooltip-id="ttFooterTooltip"><SiFacebook/></Nav.Link>
                    <Nav className="footerSep" >&#160;</Nav>
                    <Nav.Link className="footerIcon" target="_social"
                              href="https://twitter.com/creharmony"
                              data-tooltip-content="X (ex. Twitter): creharmony"
                              data-tooltip-id="ttFooterTooltip"><RiTwitterXLine/></Nav.Link>
                    <Nav className="footerSep" >&#160;</Nav>
                    <Nav.Link className="footerIcon" target="_social"
                              href="https://www.instagram.com/_creharmony_"
                              data-tooltip-content="Instagram: _creharmony_"
                              data-tooltip-id="ttFooterTooltip"><SiInstagram/></Nav.Link>
                    <ReactTooltip id="ttFooterTooltip"/>
                </Navbar>
            </div>
        </>)
    }
}

export default withTranslation('common')(CFooter2);